import { Tag } from "antd";
import { FC } from "react";

import { UserRole } from "../auth/store";

interface UserRoleTagProps {
  userRole: string;
}

export const UserRoleTag: FC<UserRoleTagProps> = ({ userRole }) => {
  const tagColor = userRole === UserRole.ADMIN ? "blue" : "green";
  return (
    <Tag color={tagColor} key={userRole}>
      {userRole.toUpperCase()}
    </Tag>
  );
};
